import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import {
    StyledPpaSplitSearchButton,
    StyledPpaSplitSearchGroup,
} from './ppaSplitSearch.styles';

export { PPA_SPLIT_SEARCH_WIDTH } from './ppaSplitSearch.styles';

export type PpaSplitSearchInputProps = {
    value?: string;
    onChange?: (value: string) => void;
    onSubmit?: (override?: string) => void;
    placeholder?: string;
    width?: number | string;
    className?: string;
    inputClassName?: string;
    ariaLabel?: string;
    submitAriaLabel?: string;
    inputTestId?: string;
    submitTestId?: string;
};

const PpaSplitSearchInput = ({
    value = '',
    onChange,
    onSubmit,
    placeholder = 'Search',
    width,
    className,
    inputClassName,
    ariaLabel = 'Search',
    submitAriaLabel = 'Submit search',
    inputTestId,
    submitTestId,
}: PpaSplitSearchInputProps) => {
    const handleChange = (nextValue: string) => {
        onChange?.(nextValue);
        if (nextValue === '') {
            onSubmit?.('');
        }
    };

    const handleSubmit = () => {
        onSubmit?.(value);
    };

    return (
        <StyledPpaSplitSearchGroup className={className} $width={width}>
            <Input
                className={['ppa-split-search-input', inputClassName].filter(Boolean).join(' ')}
                bordered={false}
                placeholder={placeholder}
                value={value}
                data-testid={inputTestId}
                aria-label={ariaLabel}
                onChange={(event) => handleChange(event.target.value)}
                onPressEnter={handleSubmit}
            />
            <StyledPpaSplitSearchButton
                type="button"
                onClick={handleSubmit}
                aria-label={submitAriaLabel}
                data-testid={submitTestId}
            >
                <SearchOutlined />
            </StyledPpaSplitSearchButton>
        </StyledPpaSplitSearchGroup>
    );
};

export default PpaSplitSearchInput;
